import React from "react";
import "./footer.css";
import { BsLinkedin, BsGithub, BsStackOverflow } from "react-icons/bs";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Ijaz Bacha
      </a>

      <ul className="footer__list">
        <li>
          <a href="#">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Experience</a>
        </li>
        <li>
          <a href="#services">Services</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials">Testimoninals</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>

      <div className="footer__social">
        <a href="https://www.linkedin.com/in/ijaz-bacha/" target="_blank">
          <BsLinkedin />
        </a>
        <a href="https://github.com/ijazbacha" target="_blank">
          <BsGithub />
        </a>
        <a href="https://stackoverflow.com/users/12519010/ijaz-bacha?tab=profile" target="_blank">
          <BsStackOverflow />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Ijaz Bacha. All right reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
